import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import Layout from "@/components/Layout";

export default function NotFound() {
  return (
    <Layout showTicker={false}>
      <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="not-found-page">
        <div className="font-display text-7xl font-extrabold text-primary">404</div>
        <h1 className="mt-4 font-display text-2xl font-extrabold text-slate-900">
          Страницата не е намерена
        </h1>
        <p className="mt-3 text-slate-600">
          Възможно е връзката да е грешна или страницата да е преместена.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white hover:bg-[#0041A8]"
        >
          <HomeIcon className="h-4 w-4" />
          Към началната страница
        </Link>
      </div>
    </Layout>
  );
}
